var exports = {
  "h_": "description__gjukZf",
  "p_": "list__arUTuw",
  "Nr": "card__Ld-8Yw",
  "Ie": "cardIcon__LYKpWy",
  "ni": "iconImg__DklvXf",
  "zI": "cardBody__4BwGUu",
  "_O": "cardName__RUGx5r",
  "L_": "cardDescription__pPW53K",
  "DR": "cardCreator__qLCv2b",
  "Zj": "configureButton__vWXSlu",
  "qr": "footer__zx2307",
  "r": "dismissButton__rzm7yD",
};

module.exports = exports;
